import { render } from "./ApiRecord.vue?vue&type=template&id=eb02cc7a&scoped=true"
import script from "./ApiRecord.vue?vue&type=script&lang=js"
export * from "./ApiRecord.vue?vue&type=script&lang=js"

import "./ApiRecord.vue?vue&type=style&index=0&id=eb02cc7a&lang=less&scoped=true"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb02cc7a"]])

export default __exports__